/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useContext, useRef } from "react";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { Button } from "@repo/ui";
import { UserContext } from "utils/reducers/user";
import logo from "assets/images/tg-logo.png";
import ImagePreview from "./imagePreview";

export default function EvhrPrint({ consignments, type, request, count }: any) {
  const user = useContext(UserContext);
  const nf = Intl.NumberFormat();

  let componentRef: any = useRef();

  return (
    <>
      <div style={{ display: "none" }}>
        <ComponentToPrint
          nf={nf}
          type={type}
          ref={(el) => (componentRef = el)}
          userDetails={user}
          consignments={consignments}
          request={request}
          count={count}
        />
      </div>

      <ReactToPrint
        trigger={() => {
          return <Button>Print EVHR</Button>;
        }}
        content={() => componentRef}
        pageStyle="print"
        documentTitle={`${type} EVHR`}
      />
    </>
  );
}

class ComponentToPrint extends React.Component<any> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: []
    };
  }
  componentDidMount() {
    this.setState({ data: this.payload() });
  }
  payload = () => {
    let _result = [];
    const propsData: any = this.props;
    const { vhrs, vhrNo } = propsData?.consignments || {
      vhrNo: null,
      vhrs: []
    };
    const request = propsData?.request || {};
    const slipData = vhrs[0] || {};

    let _csr = {
      name: "",
      mobileNo: "",
      employeeId: "",
      signature: "",
      signatureDate: ""
    };
    if (slipData?.siteRepresentatives.length > 0) {
      _csr = slipData?.siteRepresentatives[0];
    }

    let totalDeliveredConsignments: any = 0;
    let totalDeliveredCoins: any = 0;
    const deliveredBags = request?.deliveredConsignments?.containers || [];
    const deliveredFcTotalValueList =
      request?.deliveredConsignments?.fcList || [];
    let _deliveredFcInformation: any = [];

    let deliveredBagsInformation: any = [
      {
        label: "From",
        value: `${slipData?.onwardLocationId}-${slipData?.onwardLocationBarcode}`
      }
    ];

    deliveredFcTotalValueList?.forEach((element: any) => {
      _deliveredFcInformation = _deliveredFcInformation.concat([
        {
          label: `${element?.currency} ${propsData?.nf.format(element.declaredValue?.toFixed(2) || 0)}`,
          value: ""
        }
      ]);
    });

    deliveredBags?.forEach((element: any) => {
      const fcList =
        element.packedCurrencies?.map((itm: any) => ({
          label: `${itm.currency} ${propsData?.nf.format(itm.declaredValue?.toFixed(2) || 0)}`,
          value: ``
        })) || [];
      totalDeliveredConsignments = totalDeliveredConsignments + element.count;
      if (element.consignmentType === "Coins") {
        totalDeliveredCoins = totalDeliveredCoins + element.declaredValue;
      }
      deliveredBagsInformation = deliveredBagsInformation.concat([
        {
          label: `${element.sealNo || element.details} (${element.containerType})`,
          value: ""
        },
        ...(fcList?.length
          ? fcList
          : [
              {
                label: `${element.currency} ${propsData?.nf.format(element.declaredValue?.toFixed(2) || 0)}`,
                value: ``
              }
            ]),
        {
          label: `Count`,
          value: `${element.count}`
        },
        ...(element?.chequePieces
          ? [
              {
                label: `Cheque Pieces`,
                value: `${element?.chequePieces}`
              }
            ]
          : []),
        ...(element?.remarks
          ? [
              {
                label: `Remarks`,
                value: `${element.remarks}`
              }
            ]
          : [])
      ]);
    });

    _result = [
      {
        label: "TRANSGUARD",
        value: "",
        type: "heading",
        style: {
          font: "normal normal bold 50px/70px DM Sans, arial"
        }
      },
      {
        label: "Electronic Valuable Handling Receipt",
        value: ""
      },
      {
        label: "Receipt No",
        value: vhrNo
      },
      {
        label: "Service Date",
        value: slipData?.locationArrivalTime?.split(" ")[0]
      },
      {
        label: "Site Arrival Time",
        value: `${slipData?.locationArrivalTime?.split(" ")[1]} ${slipData?.locationArrivalTime?.split(" ")[2]}`
      },
      {
        label: "Service Completion Time",
        value: `${slipData?.serviceCompletionTime?.split(" ")[1]} ${slipData?.serviceCompletionTime?.split(" ")[2]}`
      },
      {
        label: "Route ID",
        value: request?.routeNo
      },
      {
        label: "Vehicle #",
        value: request?.vanRegistrationNo
      },

      {
        label: "Customer",
        value: request?.billingCustomerName || request?.customer
      },
      {
        label: "Location",
        value:
          request?.locationId ||
          (propsData?.consignmentsDetail?.vhrType === "Delivery" &&
          propsData?.type === "B2B"
            ? request?.onwardLocationId
            : request?.sourceLocationId)
      },
      {
        label: "Barcode",
        value:
          request?.barcode ||
          (propsData?.consignmentsDetail?.vhrType === "Delivery" &&
          propsData?.type === "B2B"
            ? request?.onwardLocationBarcode
            : request?.sourceLocationBarcode)
      },
      {
        label: "Service Point",
        value:
          request?.locationName ||
          (propsData?.consignmentsDetail?.vhrType === "Delivery" &&
          propsData?.type === "B2B"
            ? request?.onwardLocationName
            : request?.sourceLocationName)
      },
      ...(request?.serviceType === "Exchange Service"
        ? [
            {
              label: "Service Type",
              value: request?.jobType,
              style: { marginBottom: "25px" }
            }
          ]
        : [
            {
              style: { marginBottom: "25px" }
            }
          ]),
      ...(request?.deliveredConsignments &&
      (!request?.deliveredConsignments?.vhrNo ||
        (request?.jobType === "Exchange" &&
          request?.deliveredConsignments?.vhrNo === vhrNo)) &&
      slipData?.vhrEditType === "Main Collection" &&
      propsData?.count === 0
        ? [
            {
              label: "Total Delivered",
              value: totalDeliveredConsignments,
              type: "heading",
              style: { marginTop: "25px", fontWeight: 600 }
            },
            ...deliveredBagsInformation,

            ...(totalDeliveredCoins
              ? [
                  {
                    label: "Coins Total Values (Delivered)",
                    value: ``,
                    style: { marginTop: "25px", fontWeight: 600 }
                  },
                  {
                    label: `AED ${propsData?.nf.format(totalDeliveredCoins || 0)}`,
                    value: ""
                  }
                ]
              : []),
            ...(request?.deliveredConsignments?.lcTotalValue -
              totalDeliveredCoins >
            0
              ? [
                  {
                    label: "Total Values (Delivered)",
                    value: ``,
                    style: { fontWeight: 600 }
                  },
                  {
                    label: `AED ${propsData?.nf.format(request?.deliveredConsignments?.lcTotalValue - totalDeliveredCoins || 0)}`,
                    value: ""
                  }
                ]
              : []),
            ..._deliveredFcInformation
          ]
        : []),
      ...(request?.markedPending
        ? [
            {
              label: "Service Marked Pending",
              value: ""
            },
            {
              label: "Pending Reason",
              value: request?.pendingReason || "N/A"
            },
            {
              label: "Pending Remarks",
              value: request?.pendingRemarks || "N/A"
            }
          ]
        : propsData?.consignments?.vhrs
            ?.map((item: any, i: number) =>
              getBagsDetail(
                item,
                i,
                propsData?.consignments?.vhrs,
                propsData?.nf
              )
            )
            .flat()),
      ...(_csr.signature || _csr.name || _csr.employeeId
        ? [
            {
              label: `Site Representative`,
              value: "",
              type: "heading",
              style: { marginTop: "25px" }
            }
          ]
        : [
            {
              style: { marginTop: "25px" }
            }
          ]),
      ...(_csr.employeeId
        ? [
            {
              label: "Emirates ID",
              value: _csr.employeeId
            }
          ]
        : []),
      ...(_csr.name
        ? [
            {
              label: "ID or Name",
              value: _csr.name
            }
          ]
        : []),
      ...(_csr.mobileNo
        ? [
            {
              label: "Mobile",
              value: _csr.mobileNo
            }
          ]
        : []),
      ...(_csr.signature
        ? [
            {
              label: "Customer Signature",
              value: "",
              image: <ImagePreview path={_csr.signature} />
            },
            {
              label: "Date",
              value: _csr.signatureDate,
              style: { marginBottom: "25px" }
            }
          ]
        : [
            {
              style: { marginBottom: "25px" },
              label: ""
            }
          ]),
      ...getFieldTemDetails(slipData),
      {
        label: "Printed on",
        value: moment().format("DD-MMM-YYYY hh:mm A ")
      },
      {
        label: "Printed By",
        value: propsData?.userDetails.DisplayName
      },
      {
        label: "Tel",
        value: "+971 4 703 0500"
      },
      {
        label: "Email",
        value: "info@transguardgroup.com"
      }
    ];

    return _result;
  };
  render() {
    return (
      <div className="col-12">
        <img className="block max-w-[200px] w-full" src={logo} alt="tg-logo" />
        {(this.state as any).data.map((row: any) => {
          if (row.type === "heading") {
            return (
              <h3
                style={{
                  margin: "6x 0 10px 0",
                  font: "normal normal bold 25px/35px DM Sans, arial",
                  letterSpacing: 1.2,
                  ...row.style
                }}
                key={row.label}
              >
                {row.label}
                {row.value ? ` : ${row.value}` : ""}
              </h3>
            );
          }
          return (
            <p
              style={{
                margin: "8px 0",
                font: "normal normal normal 25px/35px DM Sans, arial",
                letterSpacing: 1.2,
                ...row.style
              }}
              key={row.label}
            >
              {row.label}{" "}
              {row.value
                ? ` : ${row.value ? row.value : ""}`
                : row.image
                  ? row.image
                  : ""}
            </p>
          );
        })}
      </div>
    );
  }
}

function getBagsDetail(
  vhrData: any,
  index: number,
  vhrs: any,
  nf = Intl.NumberFormat()
) {
  const deliveryBags = vhrData?.containers;

  let _fcInformation: any = [];
  let _bagsInformation: any = [
    {
      label: "To",
      value: `${vhrData?.onwardLocationId}-${vhrData?.onwardLocationBarcode}`
    }
  ];

  deliveryBags?.forEach((element: any) => {
    const fcList =
      element.packedCurrencies?.map((itm: any) => ({
        label: `${itm.currency} ${nf.format(itm.declaredValue?.toFixed(2) || 0)}`,
        value: ``
      })) || [];
    _bagsInformation = _bagsInformation.concat([
      {
        label: `${element.sealNo || element.details} (${element.containerType})`,
        value: ""
      },
      ...(fcList?.length
        ? fcList
        : [
            {
              label: `${element.currency} ${nf.format(element.declaredValue?.toFixed(2) || 0)}`,
              value: ``
            }
          ]),
      {
        label: `Count`,
        value: `${element.count}`
      },
      ...(element?.chequePieces
        ? [
            {
              label: `Cheque Pieces`,
              value: `${element?.chequePieces}`
            }
          ]
        : []),
      ...(element.remarks
        ? [
            {
              label: `Remarks`,
              value: `${element.remarks}`
            }
          ]
        : [])
    ]);
  });

  let totalConsignments: any = 0;
  let lcTotalValue = 0;
  let coinsTotalValue = 0;
  let fcTotalValueList: any = [];

  vhrs?.forEach((a: any) => {
    lcTotalValue = lcTotalValue + a.lcTotalValue;

    fcTotalValueList = fcTotalValueList.concat(a?.fcList);
    a?.containers?.forEach((element: any) => {
      if (element.consignmentType === "Coins") {
        coinsTotalValue = coinsTotalValue + element.declaredValue;
      }
      totalConsignments = totalConsignments + element.count;
    });
  });

  const mergedResult = Object.values(
    fcTotalValueList.reduce((accumulator: any, currentItem: any) => {
      const { currency, declaredValue } = currentItem;

      // Check if the currency is already in our accumulator object
      if (accumulator[currency]) {
        // Duplicate found: add the value to the existing object
        accumulator[currency].declaredValue += declaredValue;
      } else {
        // First time seeing this currency: add a shallow copy to the accumulator
        accumulator[currency] = { ...currentItem };
      }

      return accumulator;
    }, {})
  );

  mergedResult?.forEach((element: any) => {
    _fcInformation = _fcInformation.concat([
      {
        label: `${element?.currency} ${nf.format(element.declaredValue?.toFixed(2) || 0)}`,
        value: ""
      }
    ]);
  });

  const _totalValue =
    vhrs?.length - 1 === index
      ? [
          ...(coinsTotalValue
            ? [
                {
                  label: `Coins Total Values (Collected)`,
                  value: ``,
                  style: { marginTop: "25px", fontWeight: 600 }
                },
                {
                  label: `AED ${nf.format(coinsTotalValue || 0)}`,
                  value: ""
                }
              ]
            : []),
          ...(lcTotalValue - coinsTotalValue > 0
            ? [
                {
                  label: `Total Values (Collected)`,
                  value: ``,
                  type: "heading"
                },
                {
                  label: `AED ${nf.format(lcTotalValue - coinsTotalValue || 0)}`,
                  value: ""
                }
              ]
            : [])
        ]
      : [];

  return [
    ...(index === 0
      ? [
          {
            label: "Total Collected",
            value: totalConsignments,
            type: "heading"
          }
        ]
      : []),
    ..._bagsInformation,
    ..._totalValue,
    ...(vhrs?.length - 1 === index ? _fcInformation : []),
    {
      label: ``,
      value: "",
      style: { marginBottom: "25px" }
    }
  ];
}
function getFieldTemDetails(fieldTeamData: any) {
  const fieldTeam = fieldTeamData?.fieldTeam || [];
  let teamLeader = { name: "", employeeId: "", nationality: "" };
  let guard = { name: "", employeeId: "", nationality: "" };
  let driver = { name: "", employeeId: "", nationality: "" };
  let tempArray = fieldTeam.filter((elm: any) => elm.role === "Team Leader");
  if (tempArray.length > 0) {
    teamLeader = tempArray[0];
  }
  tempArray = fieldTeam.filter((elm: any) => elm.role === "Guard");
  if (tempArray.length > 0) {
    guard = tempArray[0];
  }
  tempArray = fieldTeam.filter((elm: any) => elm.role === "Driver");
  if (tempArray.length > 0) {
    driver = tempArray[0];
  }

  return [
    {
      label: `Field Team`,
      value: "",
      type: "heading"
    },
    {
      label: `${teamLeader.name}-${teamLeader.employeeId}`,
      value: ""
    },
    {
      label: `${driver.name}-${driver.employeeId}`,
      value: ""
    },
    {
      label: `${guard.name}-${guard.employeeId}`,
      value: ""
    },
    fieldTeamData?.ctlSignature
      ? {
          label: `CTL Signature`,
          value: "",
          image: <ImagePreview path={fieldTeamData?.ctlSignature} />
        }
      : {},
    fieldTeamData?.guardSignature
      ? {
          label: `Custodian Signature`,
          value: "",
          image: <ImagePreview path={fieldTeamData?.guardSignature} />,
          style: { marginBottom: "25px" }
        }
      : {}
  ];
}
